import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/style/ellipse.svg")